import projection from '../generated/pwn5maf1.json';
import { AcceptanceManifest } from '../types';
export const pwn5maf1AcceptanceManifest = projection as AcceptanceManifest;
